import { Progress as AntProgress, type ProgressProps } from 'antd'
import { forwardRef } from 'react'

export type UiProgressProps = ProgressProps

export const UiProgress = forwardRef<HTMLDivElement, UiProgressProps>((props, ref) => (
  <AntProgress ref={ref} {...props} />
))

UiProgress.displayName = 'UiProgress'

export default UiProgress
